import _ from "lodash"

export let defaultSettings = {
	compose: {
		viewReply: true,
		viewQuote: true,
		viewLink: true,
		viewImages: true,
	}
}

export default {
	state: {
		loading: 0,
		sidebarThread: null,  // { id, screen_name } of thread to load
		sidebarThreadReply: null,  // if there's a reply at the end of the thread, it will be here as an object
		sidebarThreadData: null, // instead, the data can also be set directly here, bypassing API calls
		
		timelines: [],  // custom timelines of users - array of user IDs
		settings: _.cloneDeep(defaultSettings),
		triggers: {
			signIn: false,
			postThread: false,
			scheduleThread: false,
			selectAccount: false,
		}
	},
	
	reducer: (state) => ({
		timelines: state.app.timelines,
		settings: state.app.settings,
	}),
	getters: {
		settings: (state) => (section, property) => {
			return state.settings[section][property]
		}
	},
	mutations: {
		incLoading(state) {
			state.loading += 1
		},
		decLoading(state) {
			state.loading -= 1
		},
		addTimeline(state, screenName) {
			state.timelines.push(screenName)
		},
		removeTimeline(state, screenName) {
			state.timelines.splice(state.timelines.indexOf(screenName), 1)
		},
		setSetting(state, {section, property, value}) {
			state.settings[section][property] = value
		},
		
		replaceSettings(state, data) {
			state.settings = data
		},
		
		setSidebarThread(state, data) {
			state.sidebarThread = data
		},
		
		setSidebarThreadReply(state, data) {
			state.sidebarThreadReply = data
		},
	
		setSidebarThreadData(state, data) {
			state.sidebarThreadData = data
		},
		
		setTrigger(state, trigger) {
			state.triggers[trigger] = true
		},
		
		clearTrigger(state, trigger) {
			state.triggers[trigger] = false
		}
	},
	actions: {
		startLoading({commit}) {
			commit('incLoading')
		},
		stopLoading({commit}) {
			commit('decLoading')
		},
		loadThread({commit}, tweet) {
			if (tweet.in_reply_to) {
				commit('setSidebarThreadReply', tweet)
				commit('setSidebarThread', {
					id: tweet.in_reply_to.status_id,
					screen_name: tweet.in_reply_to.screen_name
				})
			} else {
				commit('setSidebarThread', {
					id: tweet.id,
					screen_name: tweet.user.screen_name
				})
			}
		},
		setThreadFromDB({commit}, tweetData) {
      commit('setSidebarThreadData', tweetData)
		},
		clearThread({commit}) {
			commit('setSidebarThread', null)
			commit('setSidebarThreadReply', null)
			commit('setSidebarThreadData', null)
		}
	},
}
